import React, { FC } from 'react';
import { UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';
import {
  Fetcher,
  isLogicError,
  useConfig,
  useFetcher,
  useQuery,
  useUserSafe,
} from '../../../utils';
import { LogicError } from '../../../utils/errorHandling';

export const VendorAssistantConfirmComponent: FC = () => {
  const { ts } = useTranslation();
  const user = useUserSafe();
  const code = useQuery().get('code');
  const { contact } = useConfig();

  const fetcher = useFetcher(async () => {
    if (!code) {
      return;
    }

    await api.confirmAssistant(user.id, code);
  }, [user.id, code]);

  return (
    <UserStateComponent>
      {code === null ? (
        <div id="noCodeFound">{ts('no_code_present_in_the')}</div>
      ) : fetcher.success ? (
        <div id="assistantSuccess">
          <h3>{ts('confirmed')}!</h3>
          <p>{ts('thank_you_for_confirming_that')}</p>
          <p>{ts('you_can_now_close_this')}</p>
        </div>
      ) : isLogicError(fetcher.error, LogicError.AssistanceRequestNotFound) ? (
        <div id="assistantFail">
          <h3>{ts('invalid_confirmation_code')}</h3>
          <p>{ts('the_confirmation_code_provided_is')}</p>
          <p>{ts('if_you_are_sure_this', contact.email.dealers)}</p>
        </div>
      ) : (
        <Fetcher result={fetcher} />
      )}
    </UserStateComponent>
  );
};
